<script setup lang="ts">
  interface ILoggedOut {
    title: string
    loginUrl: string
  }

  const { isDesktop } = useBTBreakpoints()

  defineProps<ILoggedOut>()
</script>

<template>
  <NuxtLink
    class="flex size-10 items-center justify-center gap-2 rounded text-sm font-bold no-underline md:w-full md:bg-bt-green md:px-4 md:hover:bg-bt-green-hover"
    :aria-label="title"
    :to="loginUrl"
    external
  >
    <Icon name="common/person" />
    <span v-if="isDesktop">
      {{ title }}
    </span>
  </NuxtLink>
</template>
